import CragknollImagePath from '../../assets/images/locations/01CragknollVillage.png';
import TollImagePath from '../../assets/images/locations/02TollCollectors.png';
import HuntersImagePath from '../../assets/images/locations/03HuntersTrap.png';
import DankSwampImagePath from '../../assets/images/locations/04DankSwamp.png';
import PleasantImagePath from '../../assets/images/locations/05PleasantMeadow.png';
import RemoteImagePath from '../../assets/images/locations/06RemoteFarmhouse.png';
import WishingImagePath from '../../assets/images/locations/07WishingWell.png';
import WanderingImagePath from '../../assets/images/locations/08WanderingPeddler.png';
import TravellingImagePath from '../../assets/images/locations/09TravellingMerchant.png';
import EsteemedImagePath from '../../assets/images/locations/10EsteemedCollector.png';
import NarrowImagePath from '../../assets/images/locations/11NarrowBridge.png';
import AmbushImagePath from '../../assets/images/locations/12AmbushSite.png';
import OldForestImagePath from '../../assets/images/locations/13OldForestRoad.png';
import MountainImagePath from '../../assets/images/locations/14MountainPass.png';
import BanditDenImagePath from '../../assets/images/locations/15BanditDen.png';
import HistoricImagePath from '../../assets/images/locations/16HistoricStones.png';
import DankCaveImagePath from '../../assets/images/locations/17DankCave.png';
import AncientImagePath from '../../assets/images/locations/18AncientMonument.png';
import BrokenImagePath from '../../assets/images/locations/19BrokenWagon.png';
import BattlefieldImagePath from '../../assets/images/locations/20BattlefielRemains.png';
import FrigidImagePath from '../../assets/images/locations/21FrigidCreek.png';
import BuriedImagePath from '../../assets/images/locations/22BuriedFortune.png';
import ConquerorsImagePath from '../../assets/images/locations/23ConquerorsOutlook.png';
import HostageImagePath from '../../assets/images/locations/24HostageNegotiation.png';
import GreedyImagePath from '../../assets/images/locations/25GreedyMudflats.png';
import WornImagePath from '../../assets/images/locations/26WornSignpost.png';
import ForgottenImagePath from '../../assets/images/locations/27ForgottenRuins.png';
import DeepImagePath from '../../assets/images/locations/28DeepRavine.png';
import LocalImagePath from '../../assets/images/locations/29LocalDirections.png';
import StolenImagePath from '../../assets/images/locations/30StolenSpoils.png';
import HangmansImagePath from '../../assets/images/locations/31HangmansTree.png';
import LakesideImagePath from '../../assets/images/locations/32LakesideReprieve.png';
import HermitsImagePath from '../../assets/images/locations/33HermitsHovel.png';
import DeadImagePath from '../../assets/images/locations/34DeadForest.png';
import ForlornImagePath from '../../assets/images/locations/35ForlornFields.png';
import TravellersImagePath from '../../assets/images/locations/36TravellersPath.png';
import ForsakenImagePath from '../../assets/images/locations/37ForsakenGraves.png';
import IntimidatingImagePath from '../../assets/images/locations/38IntimidatingBonePile.png';
import RansackedImagePath from '../../assets/images/locations/39RansackedVillage.png';
import ToxicImagePath from '../../assets/images/locations/40ToxicMire.png';
import { sample } from 'lodash';

import { BossType } from '../enemy/enemy.types';

export const LocationType = {
   BanditAttack: 'BanditAttack',
   BossAttack: 'BossAttack',
   EnvironmentRisk: 'EnvironmentRisk',
   FindGold: 'FindGold',
   FindPotion: 'FindPotion',
   GobboAttack: 'GobboAttack',
   Rest: 'Rest',
} as const
export type LocationType = (typeof LocationType)[keyof typeof LocationType];


export type TLocation = {
   name: string;
   imageFilePath: string;
   locationType: LocationType;
   baddieQuantity: number;
   bossType?: BossType;
   envRisk?: number;
   envDamage?: number;
   completed: boolean;

};

// 12 Beneficial locations
export function getBeneficialLocations(): TLocation[] {
   const locations = [
      {
         name: 'Pleasant Meadow',
         imageFilePath: PleasantImagePath,
         locationType: LocationType.Rest,
         baddieQuantity:0,
         completed: false
      },
      {
         name: 'Remote Farmhouse',
         imageFilePath: RemoteImagePath,
         locationType: LocationType.Rest,
         baddieQuantity:0,
         completed: false
      },
      {
         name: 'Lakeside Reprieve',
         imageFilePath: LakesideImagePath,
         locationType: LocationType.Rest,
         baddieQuantity:0,
         completed: false
      },
      {
         name: 'Ancient Monument',
         imageFilePath: AncientImagePath,
         locationType: LocationType.Rest,
         baddieQuantity:0,
         completed: false
      },
      {
         name: 'Conquerors Outlook',
         imageFilePath: ConquerorsImagePath,
         locationType: LocationType.Rest,
         baddieQuantity:0,
         completed: false
      },

      {
         name: 'Wishing Well',
         imageFilePath: WishingImagePath,
         locationType: LocationType.FindPotion,
         baddieQuantity:0,
         completed: false
      },
      {
         name: 'Stolen Spoils',
         imageFilePath: StolenImagePath,
         locationType: LocationType.FindPotion,
         baddieQuantity:0,
         completed: false
      },

      {
         name: 'Wandering Peddler',
         imageFilePath: WanderingImagePath,
         locationType: LocationType.FindGold,
         baddieQuantity:0,
         completed: false
      },
      {
         name: 'Travelling Merchant',
         imageFilePath: TravellingImagePath,
         locationType: LocationType.FindGold,
         baddieQuantity:0,
         completed: false
      },
      {
         name: 'Esteemed Collector',
         imageFilePath: EsteemedImagePath,
         locationType: LocationType.FindGold,
         baddieQuantity:0,
         completed: false
      },
      {
         name: 'Buried Fortune',
         imageFilePath: BuriedImagePath,
         locationType: LocationType.FindGold,
         baddieQuantity:0,
         completed: false
      },
      {
         name: 'Local Directions',
         imageFilePath: LocalImagePath,
         locationType: LocationType.FindGold,
         baddieQuantity:0,
         completed: false
      },
   ];
   return locations;
}

// 8 environmental locations
// random number between 1 and 6 if player's number is Greater than environment risk = travel safely. else suffer envDamage
export function getEnviornmentLocations(): TLocation[] {
   const locations = [
      {
         name: 'Hunters Trap',
         imageFilePath: HuntersImagePath,
         locationType: LocationType.EnvironmentRisk,
         baddieQuantity:0,
         envRisk: 4,
         envDamage: 8,
         completed: false
      },
      {
         name: 'Deep Ravine',
         imageFilePath: DeepImagePath,
         locationType: LocationType.EnvironmentRisk,
         baddieQuantity:0,
         envRisk: 3,
         envDamage: 6,
         completed: false
      },
      {
         name: 'Mountain Pass',
         imageFilePath: MountainImagePath,
         locationType: LocationType.EnvironmentRisk,
         baddieQuantity:0,
         envRisk: 3,
         envDamage: 4,
         completed: false
      },
      {
         name: 'Greasy Swamp',
         imageFilePath: DankSwampImagePath,
         locationType: LocationType.EnvironmentRisk,
         baddieQuantity:0,
         envRisk: 2,
         envDamage: 3,
         completed: false
      },
      {
         name: 'Frigid Creek',
         imageFilePath: FrigidImagePath,
         locationType: LocationType.EnvironmentRisk,
         baddieQuantity:0,
         envRisk: 2,
         envDamage: 3,
         completed: false
      },
      {
         name: 'Greedy Mudflats',
         imageFilePath: GreedyImagePath,
         locationType: LocationType.EnvironmentRisk,
         baddieQuantity:0,
         envRisk: 1,
         envDamage: 3,
         completed: false
      },
      {
         name: 'Old Forest Road',
         imageFilePath: OldForestImagePath,
         locationType: LocationType.EnvironmentRisk,
         baddieQuantity:0,
         envRisk: 1,
         envDamage: 1,
         completed: false
      },
      {
         name: 'Worn Signpost',
         imageFilePath: WornImagePath,
         locationType: LocationType.EnvironmentRisk,
         baddieQuantity:0,
         envRisk: 1,
         envDamage: 1,
         completed: false
      },
   ];
   return locations;
}

// 8 Bandit attacks
export function getBanditAttackLocations(): TLocation[] {
   const locations = [
      {
         name: 'Toll Collectors',
         imageFilePath: TollImagePath,
         locationType: LocationType.BanditAttack,
         baddieQuantity: 2,
         completed: false
      },
      {
         name: 'Narrow Bridge',
         imageFilePath: NarrowImagePath,
         locationType: LocationType.BanditAttack,
         baddieQuantity: 2,
         completed: false
      },
      {
         name: 'Bandit Den',
         imageFilePath: BanditDenImagePath,
         locationType: LocationType.BanditAttack,
         baddieQuantity: 3,
         completed: false
      },
      {
         name: 'Hostage Negotiation',
         imageFilePath: HostageImagePath,
         locationType: LocationType.BanditAttack,
         baddieQuantity: 2,
         completed: false
      },
      {
         name: 'Hangmans Tree',
         imageFilePath: HangmansImagePath,
         locationType: LocationType.BanditAttack,
         baddieQuantity: 2,
         completed: false
      },
      {
         name: 'Hermits Hovel',
         imageFilePath: HermitsImagePath,
         locationType: LocationType.BanditAttack,
         baddieQuantity: 1,
         completed: false
      },
      {
         name: 'Forsaken Graves',
         imageFilePath: ForsakenImagePath,
         locationType: LocationType.BanditAttack,
         baddieQuantity: 2,
         completed: false
      },
      {
         name: 'Broken Wagon',
         imageFilePath: BrokenImagePath,
         locationType: LocationType.BanditAttack,
         baddieQuantity: 2,
         completed: false
      },
   ];
   return locations;
}

// 8 Gobbo attacks
export function getGobboAttackLocations(): TLocation[] {
   const locations = [
      {
         name: 'Ambush Site',
         imageFilePath: AmbushImagePath,
         locationType: LocationType.GobboAttack,
         baddieQuantity: 4,
         completed: false
      },
      {
         name: 'Historic Stones',
         imageFilePath: HistoricImagePath,
         locationType: LocationType.GobboAttack,
         baddieQuantity: 3,
         completed: false
      },
      {
         name: 'Forgotten Ruins',
         imageFilePath: ForgottenImagePath,
         locationType: LocationType.GobboAttack,
         baddieQuantity: 4,
         completed: false
      },
      {
         name: 'Forlorn Fields',
         imageFilePath: ForlornImagePath,
         locationType: LocationType.GobboAttack,
         baddieQuantity: 1,
         completed: false
      },
      {
         name: 'Travellers Path',
         imageFilePath: TravellersImagePath,
         locationType: LocationType.GobboAttack,
         baddieQuantity: 2,
         completed: false
      },
      {
         name: 'Dank Cave',
         imageFilePath: DankCaveImagePath,
         locationType: LocationType.GobboAttack,
         baddieQuantity: 1,
         completed: false
      },
      {
         name: 'Dead Forest',
         imageFilePath: DeadImagePath,
         locationType: LocationType.GobboAttack,
         baddieQuantity: 1,
         completed: false
      },
      {
         name: 'Battlefield Remains',
         imageFilePath: BattlefieldImagePath,
         locationType: LocationType.GobboAttack,
         baddieQuantity: 4,
         completed: false
      },
   ];
   return locations;
}

// 3 boss locations
export function getBossLocations(): TLocation[] {
   const locations = [
      {
         name: 'Intimidating Bone Pile',
         imageFilePath: IntimidatingImagePath,
         locationType: LocationType.BossAttack,
         bossType: BossType.TheUgon,
         baddieQuantity:1,
         completed: false
      },
      {
         name: 'Ransacked Village',
         imageFilePath: RansackedImagePath,
         locationType: LocationType.BossAttack,
         bossType: BossType.TheBaron,
         baddieQuantity:1,
         completed: false
      },
      {
         name: 'Toxic Mire',
         imageFilePath: ToxicImagePath,
         locationType: LocationType.BossAttack,
         bossType: BossType.TheBeast,
         baddieQuantity:1,
         completed: false
      },
   ];
   return locations;
}

export function getStartLocation(): TLocation {
   return {
      name: 'Cragknoll Village',
      imageFilePath: CragknollImagePath,
      locationType: LocationType.Rest,
      baddieQuantity:0,
      completed: false
   };
}

export function getRandomLocation(): TLocation {
   const allLocations = [...getBeneficialLocations(), ...getEnviornmentLocations(), ...getBanditAttackLocations(), ...getGobboAttackLocations()];
   return sample(allLocations) as TLocation;
}


export function getRandomBoss(): TLocation {
   const allBossLocations = getBossLocations();
   return sample(allBossLocations) as TLocation;
}
